import { useState } from "react"
import { Button, Flex, InputNumber, Popover, Typography } from "antd"
import styles from "./index.css"

type MoveTemplateButtonProps = {
  position: number
  total: number
  disabled: boolean
  onMove: (position: number) => void
}

export const MoveTemplateButton = ({
  position,
  total,
  disabled,
  onMove,
}: MoveTemplateButtonProps) => {
  const [open, setOpen] = useState(false)
  const [target, setTarget] = useState<number | null>(position)
  return (
    <Popover
      trigger="click"
      open={open && !disabled}
      onOpenChange={(value) => {
        setOpen(value)
        if (value) setTarget(position)
      }}
      content={
        <Flex
          className={styles.movePopover}
          vertical
          gap={12}
        >
          <Typography.Text>移动到第几位（共 {total} 个模板）</Typography.Text>
          <InputNumber<number>
            aria-label="目标展示位置"
            min={1}
            max={total}
            precision={0}
            value={target}
            onChange={setTarget}
          />
          <Button
            type="primary"
            disabled={
              target === null ||
              target === position ||
              !Number.isInteger(target) ||
              target < 1 ||
              target > total
            }
            onClick={() => {
              if (target === null) return
              onMove(target)
              setOpen(false)
            }}
          >
            确认移动
          </Button>
        </Flex>
      }
    >
      <Button
        type="link"
        disabled={disabled}
      >
        移动
      </Button>
    </Popover>
  )
}
